import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHighValue = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M26.2508 7.5L20.0008 22.5L30.0008 55M30.0008 55L40.0008 22.5L33.7508 7.5M30.0008 55C30.7938 55 31.5742 54.8114 32.2799 54.4497C32.9856 54.088 33.5952 53.5637 34.0583 52.92L54.0333 25.455C54.6672 24.5901 55.0062 23.5444 55.0003 22.4721C54.9945 21.3999 54.6441 20.3579 54.0008 19.5L46.5008 9.5C46.0351 8.87902 45.4312 8.375 44.7369 8.02786C44.0426 7.68073 43.2771 7.5 42.5008 7.5H17.5008C16.7231 7.5001 15.9562 7.6816 15.2609 8.0301C14.5657 8.37859 13.9613 8.88446 13.4958 9.5075L6.00083 19.5C5.35723 20.3576 5.00639 21.3995 5.00009 22.4717C4.99378 23.544 5.33235 24.5899 5.96583 25.455L25.9408 52.92C26.4039 53.5637 27.0135 54.088 27.7192 54.4497C28.425 54.8114 29.2078 55 30.0008 55ZM5.00083 22.5H55.0008",
		stroke: "#0A3C93",
		strokeWidth: 2.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHighValue;
